const Exclamatory = ({ width, height, className, fillColor }: ExclamatoryProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='12' cy='12' r='12' fill='#F6BE2E' />
    <path
      d='M12.9746 15.4316H12.0166L11.6123 6.15039H13.3789L12.9746 15.4316ZM11.4365 18.0859C11.4365 17.6758 11.5361 17.3857 11.7354 17.2158C11.9346 17.04 12.1836 16.9521 12.4824 16.9521C12.7754 16.9521 13.0215 17.04 13.2207 17.2158C13.4258 17.3857 13.5283 17.6758 13.5283 18.0859C13.5283 18.4902 13.4258 18.7861 13.2207 18.9736C13.0215 19.1553 12.7754 19.2461 12.4824 19.2461C12.1836 19.2461 11.9346 19.1553 11.7354 18.9736C11.5361 18.7861 11.4365 18.4902 11.4365 18.0859Z'
      fill='#283244'
    />
  </svg>
);

export type ExclamatoryProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

Exclamatory.defaultProps = {
  width: 32,
  height: 32,
  fillColor: '#2A3745',
};

export default Exclamatory;
